import brandsSlider from './brands-slider.ts'
import ambassadorSlider from './ambassador-slider.ts'
import sectionHero from './section-hero.ts'
import sectionNews from './section-news.ts'

export default function () {
	brandsSlider()
	ambassadorSlider()
	sectionHero()
	sectionNews()
}
